import defineSection from '~/spa/section';
import sectionHead from '~/spa/head';

export default defineSection({
    head: sectionHead({title: 'Iframe test page'}),
    routes: [
        {
            path: '/iframe/test-page/',
            component: () => import(/* webpackChunkName: "iframePage" */ './IframeTestPage'),
            name: 'IframeTestPage',
        },
    ]
});
